export const MEASURE_KEY = "app_measure";